import { Controller } from '@hotwired/stimulus';

export class AccordionController extends Controller {
  static targets = [
    'button',
    'panel',
  ];
  static values = {
    alwaysOpen: {
      default: true,
      type: Boolean,
    },
    selfClose: {
      default: true,
      type: Boolean,
    }
  };

  connect() {
    this.updateAccordion();
  }

  toggle(event) {
    const currentButton = event.currentTarget;
    const currentPanel = this.panelTargets.find(panel => panel.id === currentButton.getAttribute('aria-controls'));
    const isExpanded = currentButton.getAttribute('aria-expanded') === 'true';

    if (isExpanded) {
      if (this.selfCloseValue) {
        this.collapse(currentPanel);
        currentButton.setAttribute('aria-expanded', 'false');
      }
      return;
    }

    this.expand(currentPanel);
    currentButton.setAttribute('aria-expanded', 'true');

    if (this.alwaysOpenValue) return;

    this.buttonTargets.forEach(button => {
      if (button === currentButton) return;
      button.setAttribute('aria-expanded', 'false');
    });

    this.panelTargets.forEach(panel => {
      if (panel === currentPanel) return;
      this.collapse(panel);
    });
  }

  updateAccordion() {
    this.panelTargets.forEach((panel, index) => {
      const button = this.buttonTargets[index];

      if (button.getAttribute('aria-expanded') === 'true') {
        this.expand(panel);
        return;
      }

      this.collapse(panel);
    });
  }

  collapse(panel) {
    // IMPROVE: animate?
    panel.hidden = true;
  }

  expand(panel) {
    // IMPROVE: animate?
    panel.hidden = false;
  }

  keydown(event) {
    const { key } = event;
    const buttons = this.buttonTargets;
    const currentIndex = buttons.indexOf(event.currentTarget);

    if ([ 'ArrowDown', 'ArrowRight' ].includes(key)) {
      event.preventDefault();
      const nextIndex = (currentIndex + 1) % buttons.length;
      buttons[nextIndex].focus();
      return;
    }

    if ([ 'ArrowUp', 'ArrowLeft' ].includes(key)) {
      event.preventDefault();
      const prevIndex = (currentIndex - 1 + buttons.length) % buttons.length;
      buttons[prevIndex].focus();
      return;
    }

    if (key === 'Home') {
      event.preventDefault();
      buttons[0].focus();
      return;
    }

    if (key === 'End') {
      event.preventDefault();
      buttons[buttons.length - 1].focus();
    }
  }
}
